import React, { useState } from "react";
import { Subheading } from "../../../design/heading";
import { Button } from "../../../design/button";
import EnrichParticipantDialog from "../../../components/Dialogs/EnrichParticipantDialog/EnrichParticipantDialog";
import { Participant } from "../../../models/Participant";

interface Props {
  participant: Participant;
}

const UpsellEnrichmentBanner: React.FC<Props> = ({ participant }) => {
  const [isEnrichDialogOpen, setIsEnrichDialogOpen] = useState(false);

  return (
    <>
      <div className="p-4 border border-blue-300 rounded-md bg-blue-50">
        <Subheading color="blue">Save time with enrichment</Subheading>
        <p className="mb-3 text-xs text-blue-800">
          Provide a participant’s email and we’ll attempt to autofill
          employment, education, and other background details — helping you move
          faster with more accuracy.
        </p>
        <Button color="blue" onClick={() => setIsEnrichDialogOpen(true)}>
          Enrich
        </Button>
      </div>

      <EnrichParticipantDialog
        isOpen={isEnrichDialogOpen}
        setIsOpen={setIsEnrichDialogOpen}
        participantId={participant._id}
      />
    </>
  );
};

export default UpsellEnrichmentBanner;
